var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46847 5.6543H0.57373V48.0002H6.46847V5.6543Z",
    fill: "#7AD9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3632 5.6543H6.46849V48.0002H12.3632V5.6543Z",
    fill: "#BDECFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3631 48L42.7992 48L42.7992 5.65414L12.3631 5.65414L12.3631 48Z",
    fill: "#25C0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6489 5.6543L26.9196 5.6543V0.000162601L14.6489 0.000162601V5.6543Z",
    fill: "#BDECFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3256 2.88721H26.9196V5.65412H29.3256V2.88721Z",
    fill: "#7AD9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3255 5.6543L37.2654 5.6543V2.88738L29.3255 2.88738V5.6543Z",
    fill: "#BDECFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87446 5.6543L14.6489 5.6543V0.000162601L8.87446 0.000162601V5.6543Z",
    fill: "#7AD9FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3632 48H0.57373L6.46847 42.1052L12.3632 48Z",
    fill: "#89DDFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9899 12.2915V16.9372C34.9899 21.1249 31.595 24.5198 27.4072 24.5198V24.5198C23.2195 24.5198 19.8246 21.1249 19.8246 16.9372V12.2915",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7452 48.0001H24.6339C23.888 48.0001 23.2865 47.3986 23.2865 46.6528V33.3234C23.2865 32.5776 23.888 31.9761 24.6339 31.9761H46.7452C47.491 31.9761 48.0925 32.5776 48.0925 33.3234V46.6528C48.0925 47.3986 47.491 48.0001 46.7452 48.0001Z",
    fill: "#BDECFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0925 35.1304H23.3106V38.2582H48.0925V35.1304Z",
    fill: "#7AD9FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0759 45.4525C44.3196 45.4525 45.3278 44.4443 45.3278 43.2006C45.3278 41.9569 44.3196 40.9487 43.0759 40.9487C41.8322 40.9487 40.824 41.9569 40.824 43.2006C40.824 44.4443 41.8322 45.4525 43.0759 45.4525Z",
    fill: "#25C0FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1809 45.4525C41.4246 45.4525 42.4328 44.4443 42.4328 43.2006C42.4328 41.9569 41.4246 40.9487 40.1809 40.9487C38.9372 40.9487 37.929 41.9569 37.929 43.2006C37.929 44.4443 38.9372 45.4525 40.1809 45.4525Z",
    fill: "#62D2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.c83f4e6a6eca3b78c7d4d8cdcfdcfbd3.svg";
export { ForwardRef as ReactComponent };